export const POWERCHARGELOG_LIST_REQUEST = 'POWERCHARGELOG_LIST_REQUEST';

export const POWERCHARGELOG_LIST = 'POWERCHARGELOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_POWERCHARGELOG_PAGINATION = 'SET_POWERCHARGELOG_PAGINATION';

export const POWERCHARGELOG_PAGE_RESET = 'POWERCHARGELOG_PAGE_RESET';
